import { render, staticRenderFns } from "./CompanyGroupFilter.vue?vue&type=template&id=70249473&"
import script from "./CompanyGroupFilter.vue?vue&type=script&lang=js&"
export * from "./CompanyGroupFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports